// src/pages/AttendanceOverview/attendanceOverviewSelectors.js
export const selectAttendanceCalendar = (state) =>
  state.attendanceOverview?.calendarData || null;

export const selectAttendanceSummary = (state) =>
  state.attendanceOverview?.attendanceSummary || {};

export const selectEmployeeAttendanceSummary = (state) =>
  state.attendanceOverview?.employeeAttendanceSummary || null;

export const selectleaveDetailsSumary = (state) =>
  state.attendanceOverview?.leaveDetailsSumary || {};

export const selectPendingRequests = (state) =>
  state.attendanceOverview?.pendingRequests || { pending: [], attendance: [] };

export const selectHolidayList = (state) =>
  state.attendanceOverview?.holidayList || [];

export const selectEmployees = (state) =>
  state.attendanceOverview?.employees || [];

export const selectShiftReport = (state) =>
  state.attendanceOverview?.shiftReport || [];

export const selectShiftDates = (state) => 
  state.attendanceOverview.shiftDates;

export const selectShiftDatesLoaded = (state) =>
  state.attendanceOverview.shiftDatesLoaded;

export const selectAttendanceReport = (state) =>
  state.attendanceOverview?.attendanceReport || [];

export const selectApproveAttendanceReport = (state) =>
  state.attendanceOverview?.approveAttendanceReport || [];

export const selectTimeSheetReport = (state) =>
  state.attendanceOverview?.timeSheetReport || [];

export const selectAttendanceLoading = (state) =>
  state.attendanceOverview?.loading || false;

export const selectAttendanceError = (state) =>
  state.attendanceOverview?.error || null;

export const selectSelectedDate = (state) =>
  state.attendanceOverview?.selectedDate || null;

export const selectAttendanceSuccess = (state) =>
  state.attendanceOverview?.successMessage || null;

export const checkInStatus = (state) =>
  state.attendanceOverview?.checkInStatus || null;

export const selectHrLocation = (state) =>
  state.attendanceOverview?.getHrlocation || null;

export const selectShiftDetails = (state) =>
  state.attendanceOverview?.shiftDetails || null;